<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import AlertError from "@/components/alert_error";
import { VueContentLoading } from "vue-content-loading";
import QrCodeCard from "@/components/qr_code_card";

export default {
  page: {
    title: "أستمارة المنح الدراسية",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading, QrCodeCard },
  data() {
    return {
      title: "تفاصيل الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/",
        },
        {
          text: "أستمارة المنح الدراسية",
          href: "/scholar_ships",
        },
        {
          text: "التفاصيل",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      loadingContent: true,
      student: null,
      qrCodeContent: null,
      showAlert: false,
    };
  },
  computed: {
    ...mapGetters("scholarshipsStudent", ["getStudent"]),
  },
  methods: {
    ...mapActions("scholarshipsStudent", ["get"]),
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    fetch() {
      this.get(this.id)
        .then(() => {
          this.student = this.getStudent;
          this.loadingContent = false;

          this.qrCodeContent = JSON.stringify({
            Id: this.student.qr_id,
            fullName: this.student.full_name,
            date: this.student.created_at,
          });
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingContent = false;
        });
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingContent = false;
    // }, 1000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

        <div class="card">
          <div v-if="!loadingContent" class="card-body">
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">بيانات الطالب الشخصية</h5></div>
            <div class="row about-list">
              <h4>{{ student.full_name }}</h4>
              <div class="col-md-4">
                <div class="media">
                  <label>اللقب :</label>
                  <p>{{ student.family_name }}</p>
                </div>
                <div class="media">
                  <label>اسم الام الثلاثي :</label>
                  <p>{{ student.mother_name }}</p>
                </div>
                <div class="media">
                  <label>الجنس :</label>
                  <p>{{ student.gender.title }}</p>
                </div>
                <div class="media">
                  <label>تاريخ التولد :</label>
                  <p>{{ student.birth_date }}</p>
                </div>
                <div class="media">
                  <label>رقم الهاتف :</label>
                  <p>{{ student.phone }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>فصيلة الدم :</label>
                  <p>{{ student.blood_type.title }}</p>
                </div>
                <div class="media">
                  <label>الديانة :</label>
                  <p>{{ student.religion.title }}</p>
                </div>
                <div class="media">
                  <label>الحالة الاجتماعية :</label>
                  <p>{{ student.marital_status.title }}</p>
                </div>
                <div
                  v-if="student.marital_status.id != 1 && student.marital_status.id != 5"
                  class="media"
                >
                  <label>عدد الاولاد :</label>
                  <!-- فقط اذا كان متزوج  -->
                  <p>{{ student.number_children }}</p>
                </div>
                <div class="media">
                  <label>المهنة :</label>
                  <p>{{ student.job.title }}</p>
                </div>
                <div class="media">
                  <label>مكان العمل :</label>
                  <p>{{ student.job_details }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>رقم الجواز :</label>
                  <p>{{ student.passport_number }}</p>
                </div>
                <div class="media">
                  <label>تاريخ نفاذ الجواز :</label>
                  <p>{{ student.passport_expire }}</p>
                </div>
                <div class="media">
                  <label>المحافظة :</label>
                  <p>{{ student.address.city.title }}</p>
                </div>
                <div class="media">
                  <label>المنطقة :</label>
                  <p>{{ student.address.region }}</p>
                </div>
                <div class="media">
                  <label>اقرب نقطة دالة :</label>
                  <p>{{ student.address.nearest_point }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات فئة المتقدم</h5></div>
            <div class="row about-list">
              <div class="col-md-12">
                <div class="media">
                  <label> فئة المتقدم للدراسة :</label>
                  <p>{{ student.category.title }}</p>
                </div>
                <div class="media">
                  <label> تفاصيل العمل التطوعي مع الحشد للمتقدم للدراسة :</label>
                  <p>{{ student.volunteer_details }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">اسم المعرف ومكان عمله</h5></div>
            <div class="row about-list">
              <h4>{{ student.broker_full_name }}</h4>
              <div class="col-md-12">
                <div class="media">
                  <label>مكان عمل المعرف :</label>
                  <p>{{ student.broker_job }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات التحصيل الدراسي</h5></div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>التحصيل الدراسي :</label>
                  <p>{{ student.certificate_info.certificate.title }}</p>
                </div>
                <div class="media">
                  <label>التخصص الدراسي :</label>
                  <!-- اذا كان التحصيل الدراسي اعدادية يصبح النص هو الفرع الدراسي  -->
                  <p>{{ student.certificate_info.specialization }}</p>
                </div>
                <div class="media">
                  <label>المعدل :</label>
                  <p>{{ student.certificate_info.avg }}</p>
                </div>
                <div class="media">
                  <label>سنة التخرج :</label>
                  <p>{{ student.certificate_info.graduation_year }}</p>
                </div>
              </div>
              <div v-if="student.certificate_info.certificate.id != 1" class="col-md-4">
                <div class="media">
                  <label>اسم الجامعة :</label>
                  <!-- اخفاء في حال التحصيل الدراسي اعدادية  -->
                  <p>{{ student.certificate_info.university_name }}</p>
                </div>
                <div class="media">
                  <label>اسم الكلية :</label>
                  <!-- في حال التحصيل الدراسي دبلوم يصبح اسم المعهد  -->
                  <!-- اخفاء في حال التحصيل الدراسي اعدادية  -->
                  <p>{{ student.certificate_info.college_name }}</p>
                </div>
                <div class="media">
                  <label>اسم القسم :</label>
                  <!-- اخفاء في حال التحصيل الدراسي اعدادية  -->
                  <p>{{ student.certificate_info.department_name }}</p>
                </div>
                <div class="media">
                  <label>نوع الدراسة :</label>
                  <!-- اخفاء في حال التحصيل الدراسي اعدادية  -->
                  <p>{{ student.certificate_info.study_time_type.title }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div v-if="student.certificate_info.certificate.id != 1" class="media">
                  <label>نوع الجامعة :</label>
                  <!-- اخفاء في حال التحصيل الدراسي اعدادية  -->
                  <p>{{ student.certificate_info.university_type.title }}</p>
                </div>
                <div class="media">
                  <label>مكان الدراسة :</label>
                  <p>{{ student.certificate_info.study_location_type.title }}</p>
                </div>
                <div
                  v-if="student.certificate_info.study_location_type.id == 2"
                  class="media"
                >
                  <label>هل تمت معادلة الشهادة :</label>
                  <!-- اخفاء في حال مكان الدراسة داخل القطر  -->
                  <p>
                    {{ student.certificate_info.certificate_equalized ? "نعم" : "لا" }}
                  </p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">معلومات الدراسة المتقدم لها الطالب</h5>
            </div>
            <div class="row about-list">
              <div class="col-md-12">
                <div class="media">
                  <label>المستوى الدراسي :</label>
                  <p>{{ student.certificate_info.new_certificate.title }}</p>
                </div>
                <div class="media">
                  <label>التخصص الدراسي الاول الذي يرغب فيه :</label>
                  <p>{{ student.certificate_info.choice1 }}</p>
                </div>
                <div class="media">
                  <label>التخصص الدراسي الثاني الذي يرغب فيه :</label>
                  <p>{{ student.certificate_info.choice2 }}</p>
                </div>
                <div class="media">
                  <label>التخصص الدراسي الثالث الذي يرغب فيه :</label>
                  <p>{{ student.certificate_info.choice3 }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">تنزيل المرفقات</h5></div>
            <div class="row about-list">
              <div class="col-md-12">
                <a :href="student.attachment.avatar_url" target="_blank">
                  <b-button
                    :disabled="!student.attachment.avatar_url"
                    variant="primary"
                    type="button"
                    class="me-2"
                    >الصورة الشخصية</b-button
                  >
                </a>
                <a :href="student.attachment.national_url" target="_blank">
                  <b-button
                    :disabled="!student.attachment.national_url"
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق البطاقة الوطنية</b-button
                  >
                </a>
                <a :href="student.attachment.medical_report_url" target="_blank">
                  <b-button
                    :disabled="!student.attachment.medical_report_url"
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق التقرير الطبي</b-button
                  >
                </a>
                <a :href="student.attachment.passport_url" target="_blank">
                  <b-button
                    :disabled="!student.attachment.passport_url"
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق جواز السفر</b-button
                  >
                </a>
                <a :href="student.attachment.certificate_url" target="_blank">
                  <b-button
                    :disabled="!student.attachment.certificate_url"
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق وثيقة التخرج بالدرجات</b-button
                  >
                </a>
              </div>
            </div>

            <QrCodeCard
              title="استمارة المنح الدراسية"
              :fullName="this.student.full_name"
              :date="this.student.created_at"
              :Id="this.student.qr_id"
              :qrCodeContent="this.qrCodeContent"
            ></QrCodeCard>

            <div class="mt-3">
              <hr />
              <b-button class="" type="button" to="/scholar_ships" variant="secondary"
                >رجوع</b-button
              >
            </div>
          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
